module.exports = __webpack_public_path__ + "img/icon-calendario.outline.6b43a6b9.svg";